import z from 'zod';

export const apiConnectorAuthTypeSchema = z.enum(['basic', 'oauth2', 'apikey']);

export const apiConnectorSchema = z
	.object({
		id: z.string(),
		name: z.string(),
		authType: apiConnectorAuthTypeSchema.default('basic'),
		destination: z.string().optional(),
		authCredentials: z.string().optional(),
		lastSuccessFullStartedAt: z.coerce.date().optional(),
		model: z.string().optional(),
		populate: z.string().optional(),
		query: z.record(z.string(), z.unknown()).optional(),
		mapping: z.record(z.string(), z.string()).optional(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
	})
	.describe('APIConnector');
